import React from "react";

import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import HistoricalMetricPage from "./HistoricalMetricPage";

/**
 * INSIGHT-HIST-15 — Historical Delivery performance.
 *
 * The Preparation screen with the Delivery metric, plus the driver filter.
 * An order delivered by an unknown driver still appears; leaving the driver
 * filter empty keeps every delivery in view.
 */
const HistoricalDeliveryPage: React.FunctionComponent<{}> = () => (
  <HistoricalMetricPage
    metricType="DELIVERY"
    title="Delivery Time Report"
    showDriver
  />
);

export default withAuthority(
  HistoricalDeliveryPage,
  Authorities.CUSTOMER_LIST_READ
);
